import axios from 'axios'

export const gallery = {
  namespaced: true,
  state: () => ({
    program: {},
    list: []
  }),

  mutations: {
    setProgram(state, program) {
      state.program = program
    },
    setGallery(state, gallery) {
      state.list = gallery
    }
  },

  actions: {
    async getProgram({ commit }) {
      const {
        VUE_APP_URL = "",
        VUE_APP_URL_LANG = "",
        VUE_APP_URL_TYPE = "",
        VUE_APP_URL_NAME = ""
      } = process.env;
      const url = `${VUE_APP_URL}${VUE_APP_URL_LANG}${VUE_APP_URL_TYPE}${VUE_APP_URL_NAME}`;
      await axios
        .get(`${url}program.json`)
        .then(res => {
          commit('setProgram', res.data)
        })
    },
    async getGallery({ commit }) {
      const {
        VUE_APP_URL = "",
        VUE_APP_URL_LANG = "",
        VUE_APP_URL_TYPE = "",
        VUE_APP_URL_NAME = ""
      } = process.env;
      const url = `${VUE_APP_URL}${VUE_APP_URL_LANG}${VUE_APP_URL_TYPE}${VUE_APP_URL_NAME}`;
      await axios
        .get(`${url}gallery.json`)
        .then(res => {
          commit('setGallery', res.data.media)
        })
    }
  }
}
